<template>
    <footer class="page-footer" :class="[isSinglePage ? 'single' : 'multi']">
        <div class="card" v-if="isSinglePage">
            <div
                class="next"
                :style="{
                    backgroundColor: btnBgColor ? btnBgColor : null
                }"
                v-if="isJumpToEnd || isLastPage"
                @click="handleSubmitQuestion"
            >
                <div class="inner">提交问卷</div>
            </div>
            <div class="preview-next" v-else-if="isMiddlePage">
                <div class="top" @click="handlePrepage">上一题</div>
                <div class="down" @click="handleJumpNext">
                    <div class="inner">下一题</div>
                </div>
            </div>
            <div class="next" v-else @click="handleJumpNext">
                <div class="inner">下一题</div>
            </div>
        </div>
        <div class="long" v-else>
            <div
                class="next-page"
                :class="{ active: currentPageFillAnswer }"
                :style="{
                    backgroundColor: currentPageFillAnswer ? (btnBgColor ? btnBgColor : null) : null
                }"
                v-if="isJumpToEnd || isLastPage"
                @click="handleMultiSubmit"
            >
                提交问卷
            </div>
            <div class="preview-next" v-else-if="isMiddlePage">
                <div class="top" @click="handlePrepage">上一页</div>
                <div
                    class="down"
                    @click="handleMultiNextPage"
                    :style="{
                        backgroundColor: btnBgColor ? btnBgColor : null
                    }"
                >
                    下一页
                </div>
            </div>
            <div
                class="next-page active"
                :style="{ backgroundColor: btnBgColor ? btnBgColor : null }"
                v-else
                @click="handleMultiNextPage"
            >
                下一页
            </div>
        </div>
    </footer>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import { CHANGE_CURRENT_PAGE } from '@/libs/constant';
import { QuestionType, QuestionJumpType, OptionJumpType } from '@/libs/enum';
import bottomBtnInactive from '@/assets/images/bottom-btn-inactive.png';
import bottomBtnActive from '@/assets/images/bottom-btn-active.png';

export default {
    name: 'page-step',
    data() {
        return {
            bottomBtnActive,
            bottomBtnInactive
        };
    },
    computed: {
        ...mapGetters(['allPageLength']),
        ...mapState(['pictureConfig']),
        currentPage() {
            return this.$store.state.currentPage;
        },
        isSinglePage() {
            return this.$store.state.isSinglePage;
        },
        displayQuestions() {
            return this.$store.state.displayQuestions;
        },
        page() {
            return this.$store.state.page;
        },
        currentPageFillAnswer() {
            return this.$store.getters.currentPageFillAnswer;
        },
        isFirstPage() {
            return Number(this.allPageLength) > 1 && Number(this.currentPage) <= 1;
        },
        isMiddlePage() {
            return (
                Number(this.currentPage) > 1 &&
                Number(this.currentPage) < Number(this.allPageLength)
            );
        },
        isLastPage() {
            return Number(this.currentPage) >= Number(this.allPageLength);
        },
        isJumpToEnd() {
            return this.$store.state.jumpToEndFlag;
        },
        btnBgColor() {
            return this.pictureConfig.btnBg || '#ff6b20';
        }
    },
    methods: {
        jumpBySingle(question) {
            const answer = question.anwser;
            const { jumpToEnd } = question.questionJumpConfig;
            if (jumpToEnd === true) {
                this.$store.dispatch('jumpSingleQuestion', { toEnd: true });
                return;
            }
            const { jumpType } = question.questionJumpConfig;
            // 跳题类型。1表示按选项跳题，题目是单选时可以按选项跳题；2表示无条件跳题(按题目跳题)
            if (jumpType === QuestionJumpType.byNothing) {
                const questionIdentifier = question.questionJumpConfig.jumpToQuestion;
                this.$store.dispatch('jumpSingleQuestion', { jumpQidentifier: questionIdentifier });
                return;
            }
            if (jumpType === QuestionJumpType.byOption) {
                const { optionJumpConfigs } = question.questionJumpConfig;
                const findJumpOption = optionJumpConfigs.find(
                    conf => conf.optionIdentifier === answer
                );
                if (findJumpOption) {
                    const optionJumpType = findJumpOption.jumpType;
                    // 选项跳转类型。1 表示不跳转，顺序显示下一题；2 直接结束作答；3 提交为无效答卷；4 跳转到目标题目
                    if (optionJumpType === OptionJumpType.toTarget) {
                        this.$store.dispatch('jumpSingleQuestion', {
                            jumpQidentifier: findJumpOption.jumpToQuestion
                        });
                        return;
                    }
                    if (optionJumpType === OptionJumpType.toEnd) {
                        this.$store.dispatch('jumpSingleQuestion', { toEnd: true });
                        return;
                    }
                    if (optionJumpType === OptionJumpType.submitInvalid) {
                        this.$toast('直接结束作答');
                    }
                    this.$store.dispatch('jumpSingleQuestion');
                } else {
                    this.$store.dispatch('jumpSingleQuestion');
                }
            } else {
                this.$store.dispatch('jumpSingleQuestion');
            }
        },
        jumpByMulti(question) {
            const { jumpToEnd } = question.questionJumpConfig;
            if (jumpToEnd === true) {
                this.$store.dispatch('jumpSingleQuestion', { toEnd: true });
                return;
            }
            const { jumpType } = question.questionJumpConfig;
            // 跳题类型。1表示按选项跳题，题目是单选时可以按选项跳题；2表示无条件跳题(按题目跳题)
            if (jumpType === QuestionJumpType.byNothing) {
                const questionIdentifier = question.questionJumpConfig.jumpToQuestion;
                this.$store.dispatch('jumpSingleQuestion', { jumpQidentifier: questionIdentifier });
                return;
            }
            this.$store.dispatch('jumpSingleQuestion');
        },
        jumpByFillBlank(question) {
            const { jumpToEnd } = question.questionJumpConfig;
            if (jumpToEnd === true) {
                this.$store.dispatch('jumpSingleQuestion', { toEnd: true });
                return;
            }
            const { jumpType } = question.questionJumpConfig;
            // 跳题类型。1表示按选项跳题，题目是单选时可以按选项跳题；2表示无条件跳题(按题目跳题)
            if (jumpType === QuestionJumpType.byNothing) {
                const questionIdentifier = question.questionJumpConfig.jumpToQuestion;
                this.$store.dispatch('jumpSingleQuestion', { jumpQidentifier: questionIdentifier });
                return;
            }
            this.$store.dispatch('jumpSingleQuestion');
        },
        handleJumpNext() {
            window.scrollTo(0, 0);
            // 卡片式 - 每页一题
            const question = this.displayQuestions[0];
            if (question.questionType === QuestionType.single) {
                this.jumpBySingle(question);
            } else if (question.questionType === QuestionType.multi) {
                this.jumpByMulti(question);
            } else if (question.questionType === QuestionType.fillblank) {
                this.jumpByFillBlank(question);
            }
        },
        handlePrepage() {
            window.scrollTo(0, 0);
            this.$store.commit(CHANGE_CURRENT_PAGE, this.currentPage - 1);
            this.$store.dispatch('prejumpPage');
        },
        async handleSubmitQuestion() {
            const res = await this.$store.dispatch('submitQuestionnaire');
            if (res) {
                this.nextPage();
            }
        },
        // 一页多题目的逻辑
        handleMultiNextPage() {
            window.scrollTo(0, 0);
            this.$store.dispatch('jumpMultiNextPage');
        },
        async handleMultiSubmit() {
            console.log('一页多提的提交问卷');
            if (!this.currentPageFillAnswer) {
                this.$toast('请完成所有选项后提交');
                return;
            }
            const res = await this.$store.dispatch('submitQuestionnaire');
            if (res) {
                this.nextPage();
            }
        },
        nextPage() {
            const { questionnaireCode, secaccount } = this.$store.state;
            this.$router.replace({
                path: '/end',
                query: {
                    code: questionnaireCode,
                    secaccount
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@mixin inner {
    width: 100%;
    height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
    // background: #ff6b20;
    border-radius: 16px;
}
@mixin preview-next {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    cursor: pointer;
    font-weight: 700;
    .top {
        background: #fafafc;
        border: 2px solid #f0f0f0;
        border-radius: 16px;
        color: #000000;
        width: 260px;
        height: 100px;
        margin-right: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .down {
        // background: #ff6b20;
        border: 2px solid #000000;
        // background-color: linear-gradient(#ffac83, #d25516);
        background-color: #ff6b20;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        border-radius: 16px;
        color: #ffffff;
        width: 392px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        .inner {
            @include inner;
            background-position: center;
            background-repeat: no-repeat;
            background-size: contain;
        }
    }
}
.single {
    position: fixed;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    background: #ffffff;
}
.multi {
    position: relative;
}
.page-footer {
    bottom: 0;
    z-index: 10;
    height: 180px;
    width: 750px;
    .card {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: center;
        align-content: center;
        font-size: 32px;
        .next {
            height: 100px;
            font-size: 32px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            // background: #ff6b20;
            border: 2px solid #000000;
            // background: url('../../assets/images/bottom-btn-active.png') no-repeat;
            // background-size: contain;
            // background: linear-gradient(#ffac83, #d25516);
            border-radius: 16px;
            width: 700px;
            color: #ffffff;
            cursor: pointer;
            font-weight: 700;
            .inner {
                @include inner;
            }
        }
        .preview-next {
            @include preview-next;
        }
    }
    .long {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        transform: translate(-50%, -50%);
        display: flex;
        justify-content: center;
        align-content: center;
        font-size: 32px;
        font-weight: 700;
        .next-page {
            height: 100px;
            font-size: 32px;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            background-repeat: no-repeat;
            background-size: contain;
            background-position: center;
            color: #acb2b7;
            border: 2px solid #000000;
            background-color: #dadee2;
            border-radius: 16px;
            width: 700px;
            cursor: pointer;
        }
        .preview-next {
            @include preview-next;
        }
        .active {
            // background-image: url('../../assets/images/bottom-btn-active.png');
            background-repeat: no-repeat;
            background-size: contain;
            background: #ff6b20;
            color: #ffffff;
        }
    }
}
</style>
